module.exports = __webpack_public_path__ + "img/x2.4361ee39.svg";